import { render, staticRenderFns } from "./LotdMJComponent.vue?vue&type=template&id=a4038c9c&scoped=true"
import script from "./LotdMJComponent.vue?vue&type=script&lang=ts"
export * from "./LotdMJComponent.vue?vue&type=script&lang=ts"
import style0 from "./LotdMJComponent.vue?vue&type=style&index=0&id=a4038c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4038c9c",
  null
  
)

export default component.exports